import { MessageCircle, MapPin, FileText, Hammer } from "lucide-react";

interface Step {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const STEPS: Step[] = [
  {
    icon: <MessageCircle className="w-5 h-5" />,
    title: "Kostenloses Erstgespräch",
    description: "Wir besprechen Ihre Situation und klären offene Fragen — telefonisch, per WhatsApp oder vor Ort.",
  },
  {
    icon: <MapPin className="w-5 h-5" />,
    title: "Vor-Ort-Termin",
    description: "Unser Experte prüft die Gegebenheiten und erstellt ein individuelles Angebot.",
  },
  {
    icon: <FileText className="w-5 h-5" />,
    title: "Angebot & Antrag",
    description: "Sie erhalten ein verbindliches Angebot. Wir unterstützen Sie beim Förderantrag.",
  },
  {
    icon: <Hammer className="w-5 h-5" />,
    title: "Umsetzung",
    description: "Nach Förderzusage starten wir die Umsetzung — termingerecht und aus einer Hand.",
  },
];

interface SoGehtEsWeiterProps {
  testId?: string;
}

export default function SoGehtEsWeiter({ testId }: SoGehtEsWeiterProps) {
  return (
    <div
      className="bg-neko-dark-2 border border-neko-dark-3 rounded-xl p-4 mb-4"
      data-testid={testId}
    >
      <h3 className="text-sm font-semibold text-neko-white mb-4">So geht es weiter</h3>
      <div className="space-y-4">
        {STEPS.map((step, i) => (
          <div key={step.title} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className="w-8 h-8 rounded-full bg-neko-orange/15 border border-neko-orange/30 flex items-center justify-center text-neko-orange shrink-0">
                {step.icon}
              </div>
              {i < STEPS.length - 1 && (
                <div className="w-px flex-1 bg-neko-dark-3 mt-1" />
              )}
            </div>
            <div className="pb-2">
              <p className="text-sm font-medium text-neko-white">{step.title}</p>
              <p className="text-xs text-neko-gray mt-0.5 leading-relaxed">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
